var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-avatar',_vm._b({staticStyle:{"backgroundColor":"#40a9ff"}},'a-avatar',_vm.$attrs,false),[_vm._v(_vm._s(_vm._f("nameFormat")(_vm.userName)))])}
var staticRenderFns = []

export { render, staticRenderFns }